<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">ROKOVI TRAJANJA</h2>

  <div class="content-block">
    <div class="selectDates">
      <div class="odabirDatuma">
        <label>Odabir skladišta:</label>
        <dx-select-box
          #selectBoxSkladisteSirovina
          [disabled]="false"
          [items]="svaSkladista"
          [value]="svaSkladista[0].idposlovnica"
          valueExpr="idposlovnica"
          displayExpr="po_naziv_prikaz"
          [showClearButton]="true"
          [searchEnabled]="true"
          [width]="480"
          (onValueChanged)="promjenaSkladista($event)"
        >
        </dx-select-box>
      </div>
      <div class="odabirDatuma">
        <label>Odabir artikla:</label>
        <dx-select-box
          #selectBoxArtikl
          [disabled]="false"
          [items]="proizvodi"
          [value]="proizvodi[0].idartikl"
          valueExpr="idartikl"
          displayExpr="sifra_i_naziv_artikla"
          [showClearButton]="true"
          [searchEnabled]="true"
          [width]="500"
          (onValueChanged)="promjenaArtikla($event)"
        >
        </dx-select-box>
      </div>
      <div class="odabirDatuma" [style]="{ 'margin-left': '30px' }">
        <label>Pred istekom roka:</label>
        <dx-select-box
          #selectBoxIstekRoka
          [disabled]="false"
          [items]="rokArray"
          [value]="rokArray[0].predistekomroka"
          valueExpr="predistekomroka"
          displayExpr="naziv_rok"
          [width]="200"
          (onValueChanged)="promjenaRoka($event)"
        >
        </dx-select-box>
      </div>
    </div>
    <div class="customTable dnevniPlan">
      <dx-data-grid
        [dataSource]="lotRokovi"
        [wordWrapEnabled]="true"
        [showColumnLines]="true"
        noDataText="{{ poruka }}"
        keyExpr="ar_sifra"
        [showBorders]="false"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onCellPrepared)="onCellPrepared($event)"
      >
        <div *dxTemplate="let data of 'naslovTablice'">
          <div class="naslov">
            <h2 class="mb-0">LOT rokovi trajanja</h2>
            <p class="mt-0">Prikaz LOT artikla i njegovo trajanje</p>
          </div>
        </div>

        <dxo-search-panel
          [visible]="true"
          [width]="240"
          placeholder="Pretraži..."
        >
        </dxo-search-panel>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxo-grouping [autoExpandAll]="false"></dxo-grouping>

        <dxi-column
          dataField="ar_sifra"
          caption="Šifra artikla"
          [width]="150"
          alignment="left"
        ></dxi-column>
        <dxi-column
          dataField="ar_naziv"
          caption="Naziv artikla"
        ></dxi-column>
        <dxi-column
          dataField="po_naziv"
          caption="Naziv skladista"
          [width]="220"
        ></dxi-column>
        <dxi-column
          dataField="ar_lot"
          caption="LOT"
          [width]="150"
          alignment="left"
        ></dxi-column>
        <dxi-column
          dataField="ar_lotstanje"
          caption="Stanje"
          [width]="150"
          alignment="right"
        ></dxi-column>    
        <dxi-column
          dataField="ar_vazido"
          caption="Datum isteka"
          [width]="150"
          alignment="center"
          dataType="date"
        ></dxi-column>
        <dxi-column
          dataField="dana_do_isteka_roka"
          caption="Dana do isteka roka"
          [width]="180"
          alignment="right"
        ></dxi-column>
      </dx-data-grid>
    </div>
  </div>
</div>
